import '../node_modules/react-quill/dist/quill.snow.css';
import '../node_modules/react-quill/dist/quill.bubble.css';
import '../node_modules/react-quill/dist/quill.core.css';
import '../node_modules/semantic-ui-css/semantic.min.css';
import 'react-table/react-table.css';
import './styles/base.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Container, Image } from 'semantic-ui-react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import createStore, { history } from './store/Store';
import FeathersProvider from './providers/FeathersProvider';
import authorize from './components/auth/authorize';
import NavigationBar from './components/navigation/NavigationBar';
import HomeView from './components/pages/HomeView';
import TramitesView from './components/pages/TramitesView';
import InstitutionalView from './components/pages/InstitutionalView';
import SystemView from './components/pages/system/SystemView';
import AdminPublicPagesView from './components/pages/public-pages/AdminPublicPagesView';
import CooperativasView from './components/pages/cooperativas/CooperativasView';
import CooperativaDetalleView from './components/pages/cooperativas/CooperativaDetalleView';
import FinancieroView from './components/pages/financiero/FinancieroView';
import PersonasView from './components/pages/personas/PersonasView';
import MiscView from './components/pages/misc/MiscView';
import InformesView from './components/pages/informes/InformesView';
import ReportePorMatriculaView from './components/pages/informes/ReportePorMatriculaView';
import ReporteAvanzadoView from './components/pages/informes/ReporteAvanzadoView';
import ReporteEconomicoView from './components/pages/informes/ReporteEconomicoView';
import ReportePersonaView from './components/pages/informes/ReportePersonaView';
import SignInView from './components/pages/SignInView';
import SignOutView from './components/pages/SignOutView';
import UnderDevView from './components/pages/UnderDevView';
import NotFoundView from './components/pages/NotFoundView';

const AUHomeView = authorize([])(HomeView);
const AUTramites = authorize([])(TramitesView);
const AUInstitutional = authorize([])(InstitutionalView);
const AUSignInView = authorize([])(SignInView);
const AUSignOutView = authorize([])(SignOutView);
const AUCooperativasView = authorize(['sysadmin', 'supervisor', 'operator'])(CooperativasView);
const AUCooperativaDetalleView = authorize(['sysadmin', 'supervisor', 'operator'])(CooperativaDetalleView);
const AUFinancieroView = authorize(['sysadmin', 'supervisor', 'operator'])(FinancieroView);
const AUPersonasView = authorize(['sysadmin', 'supervisor', 'operator'])(PersonasView);
const AUMiscView = authorize(['sysadmin'])(MiscView);
const AUInformesView = authorize(['sysadmin', 'supervisor', 'operator', 'inquirer'])(InformesView);
const AUReportePorMatriculaView = authorize(['sysadmin', 'supervisor', 'operator', 'inquirer'])(ReportePorMatriculaView);
const AUReporteAvanzadoView = authorize(['sysadmin', 'supervisor', 'operator', 'inquirer'])(ReporteAvanzadoView);
const AUReporteEconomicoView = authorize(['sysadmin', 'supervisor', 'operator', 'inquirer'])(ReporteEconomicoView);
const AUReportePersonaView = authorize(['sysadmin', 'supervisor', 'operator', 'inquirer'])(ReportePersonaView);
const AUSystemView = authorize(['sysadmin'])(SystemView);
const AUAdminPublicPagesView = authorize(['sysadmin'])(AdminPublicPagesView);
const AUNotFoundView = authorize([])(NotFoundView);

const store = createStore();

const Refresh = ({ path = '/' }) => (
  <Route
    path={path}
    component={({ history, location, match }) => {
      history.replace({
        ...location,
        pathname: location.pathname.substring(match.path.length)
      });

      return null;
    }}
  />
);

ReactDOM.render(
  <Provider store={store}>
    <FeathersProvider>
      <ConnectedRouter history={history}>
        <Container fluid>
          <Container className="bg-green-dust no-print" fluid style={{ backgroundColor: '#72bd4b', padding: 16 }}>
            <Image src={require('./assets/img/logo_gobierno.png')} />
          </Container>
          <Container className="no-print">
            <NavigationBar />
          </Container>
          <Switch>
            <Route exact path="/" component={AUHomeView} />
            <Route path="/tramites" component={AUTramites} />
            <Route exact path="/institucional" component={AUInstitutional} />
            <Route path="/cooperativas" component={AUCooperativasView} />
            <Route path="/cooperativa/:id" component={AUCooperativaDetalleView} />
            <Route path="/financiero" component={AUFinancieroView} />
            <Route path="/personas" component={AUPersonasView} />
            <Route path="/miscelaneos" component={AUMiscView} />
            <Route path="/informes" component={AUInformesView} />
            <Route path="/reporte" component={AUReportePorMatriculaView} />
            <Route path="/reporte-avanzado" component={AUReporteAvanzadoView} />
            <Route path="/reporte-economico" component={AUReporteEconomicoView} />
            <Route path="/reporte-personas" component={AUReportePersonaView} />
            <Route path="/public" component={AUAdminPublicPagesView} />
            <Route path="/sistema" component={AUSystemView} />
            <Route exact path="/ingresar" component={AUSignInView} />
            <Route exact path="/cerrar-sesion" component={AUSignOutView} />
            <Refresh path="/refresh" />
            <Route component={AUNotFoundView} />
          </Switch>
        </Container>
      </ConnectedRouter>
    </FeathersProvider>
  </Provider>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./client/index.js